// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { download16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-download': IconDownload;
    }
}

/**
 * The icon component for the 'download' icon
 */
export class IconDownload extends IconSvg {
    public constructor() {
        super(download16X16);
    }
}

registerIconSvg('icon-download', IconDownload);
export const iconDownloadTag = 'nimble-icon-download';
